import { fetchData, uploadData } from "../utils/api";

export const productService = {
  async getProducts(page = 1, limit = 10, search = "") {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search: search }),
    });

    const response = await fetchData(`/products?${queryParams}`);
    return {
      products: response.products || [],
      currentPage: response.currentPage || page,
      totalPages: response.totalPages || 1,
      totalProducts: response.totalProducts || 0,
    };
  },
  async createProduct(formData) {
    const response = await uploadData("/products", formData);
    return response.product;
  },

  async updateProduct(id, formData) {
    const response = await uploadData(`/products/${id}`, formData, "PUT");
    return response.product;
  },

  async deleteProduct(id) {
    const response = await fetchData(`/products/${id}`, { method: "DELETE" });
    return response;
  },
};
